export default "__VITE_ASSET__BvxAwHn8__"